import PropTypes from 'prop-types';
import { useState } from 'react';
import TextField from 'components/form-components/TextField';
import chevronGreyIcon from 'assets/images/icons/chevron-grey.svg';
import linkGreenIcon from 'assets/images/icons/link-green.svg';
import linkBrokenRedIcon from 'assets/images/icons/link-broken-red.svg';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';
import { useTranslation } from 'react-i18next';

const HyperLink = ({ value, dashboardOptions, pageLookup, onChange }) => {
  const { t } = useTranslation();
  const [showContent, setShowContent] = useState(true);

  const handleChange = (field, value, path) => {
    if (field === 'linkDashboardPage') {
      onChange('linkedPageId', value);
      onChange('linkedDashboardId', path[path.length - 1]);
    }
  };

  return (
    <>
      <div className='text-and-link accordion d-flex flex-column'>
        <div className='accordion-item border-0 px-3 py-2 mb-0'>
          <div className='d-flex justify-content-between align-items-center'>
            <span className='theme-text-black-1 theme-size-1_1 theme-font-inter-medium'>
              {t('field_hyper_link')}
            </span>
            <img
              src={chevronGreyIcon}
              className={`toggle-button cursor-pointer p-2 ${showContent ? '' : 'rotate-180'}`}
              onClick={() => setShowContent((prevState) => !prevState)}
            />
          </div>
        </div>

        <div className='accordion-item border-0 theme-text-grey-1'>
          {showContent && (
            <div className='p-3 border-top-grey-10-h-1'>
              <div className='mb-2'>{t('text_connect_with_other_dashboard_or_page')}</div>
              <div className='position-relative d-flex flex-grow-1 align-items-center gap-3'>
                <TextField
                  name='hyperLinkLabel'
                  classes='w-100 textInput'
                  value={
                    pageLookup[value]
                      ? `${pageLookup[value].dashboardName}, ${pageLookup[value].pageName}`
                      : value || t('select_select')
                  }
                  handleChange={() => {}}
                  disabled
                  shrinkFieldOnly
                />
                <div className='d-flex align-items-center position-absolute end-0 theme-height-44 px-3 py-2'>
                  {value ? (
                    <div
                      className={`d-flex gap-2 cursor-pointer`}
                      onClick={() => handleChange('linkDashboardPage', '', [''])}
                    >
                      <img src={linkBrokenRedIcon} />
                      <label className='theme-text-red-1 cursor-pointer'>{t('text_unlink')}</label>
                    </div>
                  ) : (
                    <MultiLevelSelect
                      options={dashboardOptions}
                      value={[]}
                      name='linkDashboardPage'
                      handleChange={(name, value, displayValue, path) => {
                        handleChange(name, value[0], path);
                      }}
                      classes='theme-font-inter-regular'
                      toggleClasses='d-flex gap-2 justify-content-between align-items-center cursor-pointer'
                      toggleComponent={
                        <>
                          <img src={linkGreenIcon} />
                          <label className='theme-text-green-1 cursor-pointer'>
                            {t('text_link')}
                          </label>
                        </>
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

HyperLink.propTypes = {
  value: PropTypes.string.isRequired,
  dashboardOptions: PropTypes.object.isRequired,
  pageLookup: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default HyperLink;
